import * as SwitchPrimitive from '@radix-ui/react-switch'
import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

/* RTL is handled by the rtl: variant on the thumb translation rather than by
   reading direction in JavaScript — the same reason logical properties are
   preferred throughout: it cannot get out of step with the actual dir. */

export function Switch({ className, ...props }: ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        'relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-full',
        'bg-[#d1d5db] transition-colors data-[state=checked]:bg-[#4b9beb]',
        'focus-visible:ring-3 focus-visible:ring-[color-mix(in_oklab,var(--hk-ring)_45%,transparent)]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'block size-4 rounded-full bg-white shadow-sm transition-transform',
          'ms-0.5 data-[state=checked]:translate-x-[1.15rem]',
          'rtl:data-[state=checked]:-translate-x-[1.15rem]',
        )}
      />
    </SwitchPrimitive.Root>
  )
}
